import React from 'react'
import { DatePicker, Select, Space } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/es'
import locale from 'antd/es/date-picker/locale/es_ES'
import { MOVEMENT_TYPE_LABELS } from '../../../../utils/reportUtils'

const { RangePicker } = DatePicker

interface MovementReportFiltersProps {
  dateRange: [Dayjs, Dayjs]
  onDateChange: (dates: [Dayjs, Dayjs]) => void
  movementTypeFilter: string
  onMovementTypeChange: (type: string) => void
  loading?: boolean
}

const presetRanges: Record<string, [Dayjs, Dayjs]> = {
  'Hoy': [dayjs().startOf('day'), dayjs().endOf('day')],
  'Ayer': [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
  'Últimos 7 días': [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')],
  'Este Mes': [dayjs().startOf('month'), dayjs().endOf('month')],
  'Mes Anterior': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
  'Este Año': [dayjs().startOf('year'), dayjs().endOf('year')]
}

export const MovementReportFilters: React.FC<MovementReportFiltersProps> = ({
  dateRange,
  onDateChange,
  movementTypeFilter,
  onMovementTypeChange,
  loading = false
}) => {
  const handleChange = (dates: any) => {
    if (dates && dates[0] && dates[1]) {
      onDateChange([dates[0].startOf('day'), dates[1].endOf('day')])
    }
  }

  const rangePresets = Object.keys(presetRanges).map(label => ({
    label,
    value: presetRanges[label]
  }))

  return (
    <Space wrap size="middle">
      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Período:</label>
        <RangePicker
          locale={locale}
          value={dateRange}
          onChange={handleChange}
          presets={rangePresets}
          format="DD/MM/YYYY"
          disabled={loading}
          allowClear={false}
          style={{ width: 280 }}
        />
      </div>

      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Tipo de Movimiento:</label>
        <Select
          value={movementTypeFilter}
          onChange={onMovementTypeChange}
          disabled={loading}
          style={{ width: 240 }}
          options={[
            { value: 'ALL', label: 'Todos los movimientos' },
            { value: 'ENTRIES_ONLY', label: '🟢 Solo Entradas' },
            { value: 'EXITS_ONLY', label: '🔴 Solo Salidas' },
            ...Object.keys(MOVEMENT_TYPE_LABELS).map(key => ({
              value: key,
              label: MOVEMENT_TYPE_LABELS[key]
            }))
          ]}
        />
      </div>
    </Space>
  )
}

export default MovementReportFilters
